import styled, { css } from "styled-components";
import { media } from "../styles/media"; // 생성한 미디어 쿼리 헬퍼 가져오기

/******************************************************************/
/************************ 메인 배치 레이아웃 ************************/
/******************************************************************/

// 메인 영역 백그라운드
export const BackgroundArea = styled.div`
    /* 모바일 기본 */
    width: 100%;
    height: 100%;

    background: var(--BGGray, #F5F6F7);

    /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
    position: relative;     

    /* 🔑 Flexbox를 사용해 내부 요소 배치 */
    display: flex;
    flex-direction: column; /* 세로 방향으로 요소 배치 */
    // justify-content: flex-end; /* 아래쪽으로 요소를 몰아넣음 */    
    align-items: center; /* 가운데 정렬 */    


    /* 태블릿 배치 */
    ${media.tablet`
        // width: 100%;
        width: 110vw; 
        // height: 1080px;
        height: 140vh;

        // background: var(--BGGray, #b3bdc78e);
        background: var(--Grayscale-GR_F7, #F7F7F7);

        /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
        position: relative;     

        /* 🔑 Flexbox를 사용해 내부 요소 배치 */
        display: flex;
        flex-direction: column; /* 세로 방향으로 요소 배치 */
        // justify-content: flex-end; /* 아래쪽으로 요소를 몰아넣음 */    
        align-items: center; /* 가운데 정렬 */           
    `}

    /* 데스크탑 배치 */
    ${media.desktop`
        /* 데스크탑은 보통 고정 너비를 선호하거나, 최대 너비를 설정합니다. */
        width: 100vw; 
        // max-width: 1920px; /* 최대 너비 제한 */
        height: 100vh;

        // background: var(--BGGray, #b3bdc78e);
        background: var(--Grayscale-GR_F7, #F7F7F7);

        /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
        position: relative;     

        /* 🔑 Flexbox를 사용해 내부 요소 배치 */
        display: flex;
        flex-direction: column; /* 세로 방향으로 요소 배치 */
        // justify-content: flex-end; /* 아래쪽으로 요소를 몰아넣음 */    
        align-items: center; /* 가운데 정렬 */           
    `}
`;

/******************************************************************/
/************************* 네비게이션 영역 *************************/
/******************************************************************/

// 네비게이션 영역 프래임
/**
 * 
 */
export const NavFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 360px;
    padding: 25px 5px;
    justify-content: space-between;
    align-items: center;

    /* 🔑 절대 배치 유지 */
    // position: absolute;     

    /* 🔑 부모(BackgroundArea) 기준 위치 설정 */
    // top: 3.0%;     // 24/780 = 0.030
    // // left: 5.5%;    // 20/360 = 0.055
    // // right: 5.5%;    // 20/360 = 0.055
    // bottom: 89.2%;   // 696/780 = 0.892

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// only tablet, desktop
// 네비게이션 로고 영역 프레임
/**
 * 
 */
export const NavLogoFrame = styled.span`
    /* 모바일 기본 */
    display: flex;
    width: 280px;
    height: 68px;
    // padding: 3.22px 0 4.42px 0;
    // padding: 2.8px 0.919px 4px 0.719px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;    



    /* 태블릿 배치 */
    ${media.tablet`
        /* 🔑 절대 배치 유지 */
        position: absolute;

        /* 🔑 부모(BackgroundArea) 기준 위치 설정 */
        top: calc(64/1920 * 100%);
        left: calc(25/1080 * 100%);

    `}

    /* Desktop 배치 */
    ${media.desktop`
        left: calc(28/1080 * 100%);
    `}        
`;



// 네비게이션 메인 로고 아이콘
export const NavMainLogo = styled.span<{ $logoUrl: string }>`
    /* 모바일 기본 */
    width: 13.705px;
    height: 22.667px;
    flex-shrink: 0;

    background-image: url(${(props) => props.$logoUrl}); 
    // 👇 이 세 줄을 추가해 주세요!
    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */
    background-position: center; 

    /* 태블릿 배치 */
    ${media.tablet`
        width: 34.469px;
        height: 57.006px;

        /* 🔑 절대 배치 유지 */
        position: absolute;

        /* 🔑 부모(BackgroundArea) 기준 위치 설정 */
        bottom: calc(5/68 * 100%);
        right: calc(243/280 * 100%);  
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 네비게이션 로고 인 프레임
export const NavInFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 112px;
    height: 24px;
    padding-right: 0.667px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    // height: 45.421px;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 229.938px;
        height: 61.2px;

        /* 🔑 절대 배치 유지 */
        position: absolute;

        /* 🔑 부모(BackgroundArea) 기준 위치 설정 */
        top: calc(12.6/68 * 100%);
        left: calc(40/280 * 100%);        
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 네비게이션 REK 로고 아이콘
export const NavSubLogo = styled.span<{ $logoUrl: string }>`
    /* 모바일 기본 */
    width: 91.428px;
    height: 18.06px;
    flex-shrink: 0;

    display: flex;
    margin-top: 5px;
    margin-left: 2px;
    // padding: 1px 0.257px;
    // justify-content: flex-start;
    // align-items: center;
    // align-items: flex-start;

    background-image: url(${(props) => props.$logoUrl}); 
    // 👇 이 세 줄을 추가해 주세요!
    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */
    background-position: center;

    /* 태블릿 배치 */
    ${media.tablet`
        width: 100px;
        height: 61.2px;

        margin-top: 0px;
        margin-left: 0px;        
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// only mobile
export const NavImgContainer = styled.div`
    display: flex;
    justify-content: center; /* 필요에 따라 세로 정렬 */
    align-items: flex-start; /* 필요에 따라 가로 정렬 */
    /* 필요에 따라 너비(width)나 마진(margin) 조정 */
    height: 100%; /* 부모(NavInFrame) 높이에 맞춤 */
    padding-left: 5px; /* NavSubLogo와의 간격 */
`;

// only tablet, desktop
// NavSubLogoText1과 NavSubLogoText2를 묶어줄 컨테이너
export const NavTextContainer = styled.div`
    display: flex;
    flex-direction: column; /* 👈 이 두 줄이 핵심! 내부 요소(Text1, Text2)를 세로로 배치 */
    justify-content: center; /* 필요에 따라 세로 정렬 */
    align-items: flex-start; /* 필요에 따라 가로 정렬 */
    /* 필요에 따라 너비(width)나 마진(margin) 조정 */
    height: 100%; /* 부모(NavInFrame) 높이에 맞춤 */
    padding-left: 5px; /* NavSubLogo와의 간격 */
`;

// only tablet, desktop
// 네비게이션 로고 텍스트 1
export const NavSubLogoText1 = styled.span<{ $logoUrl: string }>`
    /* 모바일 기본 */
    display: flex;
    width: 81.567px;
    height: 17.032px;
    flex-shrink: 0;

    background-image: url(${(props) => props.$logoUrl}); 
    // 👇 이 세 줄을 추가해 주세요!
    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */
    background-position: center; 

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// only tablet, desktop
// 네비게이션 로고 텍스트 2
export const NavSubLogoText2 = styled.span<{ $logoUrl: string }>`
    /* 모바일 기본 */
    display: flex;
    width: 110.141px;
    height: 23.419px;
    flex-shrink: 0;

    background-image: url(${(props) => props.$logoUrl}); 
    // 👇 이 세 줄을 추가해 주세요!
    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */
    background-position: center; 

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// only tablet, desktop
// 네비게이션 메뉴 프레임
export const NavMenuFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 300px;
    padding: 12px 20px;
    align-items: center;
    gap: 16px;

    position: absolute;

    /* 🔑 부모(BackgroundArea) 기준 위치 설정 */
    // top: calc(950/1080 * 100%);
    // left: calc(20/1440 * 100%);
    top: calc(170/1080 * 100%);
    left: calc(40/1440 * 100%);      
    // top: calc(54/1080 * 100%);
    // left: calc(1300/1440 * 100%);

    /* 태블릿 배치 */
    ${media.tablet`

    `}
    
    /* Desktop 배치 */
    ${media.desktop`
        width: 376px;
    `}    
`;


// 네비게이션 하단 메뉴 아이콘
export const NavMenu = styled.span<{ $imgUrl: string;}>`
    /* 모바일 기본 */
    display: flex;
    width: 24px;
    height: 24px;
    padding: 4px 4.5px 5px 4.5px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    background-image: url(${(props) => props.$imgUrl});
    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 40px;
        height: 40px;
        padding: 6px;
    `}    
`;

// only tablet, desktop
// 네비게이션 하단 메뉴 텍스트
export const NavMenuText = styled.span`
    /* 모바일 기본 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;

    overflow: hidden;
    color: var(--Grayscale-GR_45, #454545);
    text-overflow: ellipsis;

    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 120% */


    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 24px;
        font-weight: 600;
        line-height: 28px;
    `}    
`;

export const MenuTabContainer = styled.div`
    display: flex; // inline-flex 대신 flex 사용 (또는 inline-flex 유지해도 무방)
    flex-direction: column; /* ✨ 이 부분을 추가/수정합니다: 요소들을 세로로 정렬 */
    align-items: center; /* MainContainer가 block 요소일 때 중앙 정렬 */
    gap: 30px;
`;

/******************************************************************/
/********************* 지역/사이트/그룹 선택 탭 *********************/
/******************************************************************/

// 선택 박스 프레임
export const SelectorBoxFrame = styled.div`
    /* 모바일 기본 */
    /* 🔑 절대 배치 유지 */
    // position: absolute;     

    /* 🔑 부모(BackgroundArea) 기준 위치 설정 */
    // top: 8.0%;     // 96/780 = 0.123
    // left: 5.5%;    // 20/360 = 0.055
    // right: 5.5%;    // 20/360 = 0.055
    // bottom: 73.2%;   // 571/780 = 0.732

    
    /* 태블릿 배치 */
    ${media.tablet`
        /* 🔑 절대 배치 유지 */
        position: absolute;  
        // top: calc(200/1080 * 100%);
        top: calc(270/1080 * 100%);
        left: calc(40/1440 * 100%);    
        bottom: calc(608/1080 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`
        top: calc(300/1080 * 100%);
        // bottom: calc(708/1080 * 100%);
    `}    
`;

/******************************************************************/
/************************* 그룹 디바이스 탭 ************************/
/******************************************************************/

// 그룹, 디바이스 탭 프레임
export const TabFrame = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 360px;
    height: 52px;
    padding: 0 20px;
    justify-content: center;
    align-items: flex-start;
    flex-shrink: 0;

    border-bottom: 1px solid var(--Grayscale-GR_EB, #EBEBEB);

    /* 🔑 절대 배치 유지 */
    // position: absolute;     

    /* 🔑 부모(BackgroundArea) 기준 위치 설정 */
    // top: 28.0%;     // 274/780 = 0.351
    // left: 5.5%;    // 20/360 = 0.055
    // right: 5.5%;    // 20/360 = 0.055
    // bottom: 65.5%;   // 511/780 = 0.655

    /* 태블릿 배치 */
    ${media.tablet`
        width: 460px;
        /* 🔑 절대 배치 유지 */
        position: absolute;   
        top: calc(54/1080 * 100%);
        left: calc(365/1440 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;

// 그룹, 디바이스 탭 언 포커스
export const TabUnFocus = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 110px;
    height: 52px;
    padding: 16px 0;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    color: var(--Grayscale-GR_66, #666);
    text-align: center;

    /* mobile/body1_R */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */

    /* 태블릿 배치 */
    ${media.tablet`
        width: 160px;
        font-size: 18px;
        font-weight: 600;
        line-height: 22px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 160px;
        font-size: 20px;
        font-weight: 800;
        line-height: 24px;
    `}    
`;

// 그룹, 디바이스 탭 포커스
export const TabFocus = styled.div`
    /* 모바일 기본 */
    display: flex;
    width: 110px;
    height: 52px;
    padding-top: 16px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 13px;
    flex-shrink: 0;

    color: var(--Grayscale-BK_00, #000);
    text-align: center;

    /* mobile/body1_B */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */    

    /* 태블릿 배치 */
    ${media.tablet`
        width: 160px;
        font-size: 18px;
        font-weight: 600;
        line-height: 22px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 160px;
        font-size: 20px;
        font-weight: 800;
        line-height: 24px;
    `}    
`;

// 그룹, 디바이스 탭 포커스 하단 라인
export const TabFocusLine = styled.div`
    /* 모바일 기본 */
    width: 110px;
    height: 3px;
    flex-shrink: 0;

    background: var(--Grayscale-BK_00, #000);

    /* 태블릿 배치 */
    ${media.tablet`
        width: 160px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 160px;
    `}    
`;

/******************************************************************/
/*************************** 각 메뉴 영역 **************************/
/******************************************************************/

// 각 메뉴 영역 백그라운드
export const MenuArea = styled.div`
    /* 모바일 기본 */
    /* 🔑 절대 배치 유지 */
    // position: absolute;     

    /* 🔑 부모(BackgroundArea) 기준 위치 설정 */
    // top: 35.0%;     // 338/780 = 0.433
    // left: 3.3%;    // 12/360 = 0.033
    // right: 5.5%;    // 12/360 = 0.033
    // bottom: 53.7%;   // 419/780 = 0.537

    /* 태블릿 배치 */
    ${media.tablet`
        /* 🔑 절대 배치 유지 */
        position: absolute;      
        top: calc(165/1080 * 100%);
        left: calc(360/1440 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;